import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import TicketsManagerTabs from "../../components/TicketsManagerTabs/";
import Ticket from "../../components/Ticket/";
import TicketAdvancedLayout from "../../components/TicketAdvancedLayout";
import backgroundChat from '../../assets/img/backgroundChat.png';
import { TicketsContext } from "../../context/Tickets/TicketsContextIndexedDB";
import { useTicketRoom } from "../../hooks/useTicketRoom";

import { i18n } from "../../translate/i18n";
import TicketsManager from "../../components/TicketsManager";

const useStyles = makeStyles(theme => ({
    header: {
        marginTop: theme.spacing(2),
        width: '100%',
      },
    content: {
        overflow: "auto",
        height: 'calc(100vh - 64px)',
        backgroundImage: `url(${backgroundChat})`,
      },
    placeholderContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
		background: theme.palette.total,
    },
    placeholderItem: {
    }
}));

const TicketAdvanced = (props) => {
	const classes = useStyles();
	const { ticketId } = useParams();
	const history = useHistory();
	const [option, setOption] = useState(0);
    const { currentTicket, setCurrentTicket } = useContext(TicketsContext)

    // 🆕 Une/sale del room del ticket actual según el id del path
    useTicketRoom();

    useEffect(() => {
        if(currentTicket.id !== null) {
            history.push(`/tickets/${currentTicket.id}`)
        }
        if (!ticketId) {
            setOption(1)
        }
        return () => {
            setCurrentTicket({ id: null, code: null })
        }
    }, [])

    useEffect(() => {
        if (currentTicket.id !== null) {
            setOption(0)
        }
    }, [currentTicket])

	const renderMessageContext = () => {
		if (ticketId) {
			return <Ticket setOption={setOption} />
		}
		return <TicketsManager />
	}

	const renderTicketsManagerTabs = () => {
		return <TicketsManagerTabs />
	}

	return (
        <TicketAdvancedLayout>
            <Box className={classes.content}>
                { option === 0 ? renderMessageContext() : renderTicketsManagerTabs() }
            </Box>
        </TicketAdvancedLayout>
	);
};

export default TicketAdvanced;
